import {gql} from '@apollo/client';

export const DELETE_AREA_MUTATION = gql`
  mutation deleteArea($areaId: Long!) {
    deleteArea(areaId: $areaId)
  }
`;

export interface deleteAreaResponse {
    deleteArea: boolean;
}

export interface deleteAreaVariables {
    areaId: number;
}
